module.exports = __webpack_public_path__ + "img/43-02.d126dbd3.png";